<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="isInfoPublic" class="publish-profile__public">
      <ButtonSecondary
        text="プロフィールを公開中"
        @click-secondary-button="openModal"
      />
      <TextModal
        v-if="showModal"
        title-text="プロフィールを非公開にしますか？"
        caption-text=""
        primary-button-text="非公開にする"
        cancel-button-text="キャンセル"
        @clicked-modal-cover="closeModal"
        @clicked-primary="changeInfoPublic(false)"
        @clicked-cancel="closeModal"
      />
    </div>
    <div v-else class="publish-profile__private">
      <ButtonPrimary
        text="プロフィールを公開する"
        @click-primary-button="openModal"
      />
      <TextModal
        v-if="showModal"
        title-text="プロフィールを公開しますか？"
        caption-text=""
        primary-button-text="公開する"
        cancel-button-text="キャンセル"
        @clicked-modal-cover="closeModal"
        @clicked-primary="changeInfoPublic(true)"
        @clicked-cancel="closeModal"
      />
    </div>
    <div class="publish-profile__caption">
      公開中はこのページのURLを知っている人とギフトを贈ったお相手が、あなたのプロフィールにアクセスできます。
    </div>
  </div>
</template>

<script>
import FeedbackSuccess from '../../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import TextModal from '../../../molecules/modals/text-modal.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import ButtonSecondary from '../../../molecules/buttons/ButtonSecondary.vue'

import axios from 'axios'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    TextModal,
    ButtonPrimary,
    ButtonSecondary
  },
  props: {
    isInfoPublic: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      showableSuccessFeedback: false,
      showableErrorFeedback: false,
      successMessage: '',
      errorMessage: '',
      showModal: false
    }
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    closeModal() {
      this.showModal = false
    },
    openModal() {
      this.showModal = true
    },
    async changeInfoPublic(infoPublic) {
      try {
        const res = await axios.patch(
          '/api/v1/users/@me/profiles/update_info_public',
          { info_public: infoPublic }
        )
        if (res.data.status === 200) {
          this.closeModal()
          this.showFeedback(
            infoPublic
              ? 'プロフィールを公開しました'
              : 'プロフィールを非公開にしました'
          )
          this.$emit('change-info-public', infoPublic)
        }
      } catch (error) {
        this.closeModal()
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.publish-profile {
  &__caption {
    @extend %caption;
    margin-top: 16px;
    text-align: left;
  }
}
</style>
